// extracted by mini-css-extract-plugin
export default {"container":"recent_container__3Um7L","header":"recent_header__4Bz+a","more":"recent_more__2r+Hz"};